<template>
  <b-list-group-item>
    <b-row>
      <b-col cols="5" align-self="center">
        <h4>{{ item.title }}</h4>
      </b-col>
      <b-col align-self="center" cols="3">
        <h4>{{ item.count.toLocaleString("en-US") }}</h4>
      </b-col>
      <b-col align-self="center" cols="2">
        <h4>{{ item.icon }} <feather-icon :icon="item.icon" /></h4>
      </b-col>

      <b-col cols="2" align-self="center">
        <h4>
          <b-button
            v-can="{ slug: $route.meta.slug, action: 'U' }"
            @click="activModel = true"
            type="edit"
            variant="flat-primary"
            class="btn-icon rounded-circle"
          >
            <feather-icon icon="EditIcon" />
          </b-button>

          <b-button
            @click="onDeleteClicked()"
            v-can="{ slug: $route.meta.slug, action: 'D' }"
            type="edit"
            variant="flat-danger"
            class="btn-icon rounded-circle"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </h4>
      </b-col>
    </b-row>
    <modal-statistics v-model="activModel" :item="item" type="edit">
    </modal-statistics>
  </b-list-group-item>
</template>

<script>
import ModalStatistics from "./ModalStatistics.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from "bootstrap-vue";
export default {
  props: {
    item: Object,
  },
  components: {
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BButton,
    ModalStatistics,
    BSpinner,
    ToastificationContent,
  },
  methods: {
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف ؟", {
          title: "تأكيد حذف ",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.$store.dispatch(
              "manageInterfaceNgo/statistics/deleteStatistics",
              {
                id: this.item.id,
              }
            );
          }
        });
    },
  },
  data: () => {
    return {
      activModel: false,
      deleteItem: null,
    };
  },
};
</script>
